import styled from "styled-components";

const FloatingButton = styled.a`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  background: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;

  &:hover {
    transform: scale(1.1) translateY(-4px);
    box-shadow: 0 8px 30px rgba(37, 211, 102, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(37, 211, 102, 0.3);
    transform: translate(-50%, -50%) scale(1);
    animation: pulse 2s infinite;
    z-index: -1;
  }

  @keyframes pulse {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.6);
      opacity: 0;
    }
  }

  @media (min-width: 768px) {
    bottom: 32px;
    right: 32px;
    width: 64px;
    height: 64px;
  }
`;

const WhatsAppIcon = styled.svg`
  width: 28px;
  height: 28px;
  color: white;

  @media (min-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

export { FloatingButton, WhatsAppIcon };
